import React from "react";
import FirstContentWeb from "../../../images/LandingPage/Contents/Process1/Content-1.webm";
import FirstContentMp from "../../../images/LandingPage/Contents/Process1/Content-1.mp4";

const FirstContentProcess = () => {
  return (
    <>
      <video
        loading="lazy"
        autoPlay
        loop
        muted
        playsInline
        style={{
          justifySelf: "center",
          maxWidth: 400,
          width: "100%",
          height: "auto",
          borderRadius: 4,
        }}
      >
        <source src={FirstContentWeb} type="video/webm" />
        <source src={FirstContentMp} type="video/mp4" />
      </video>
    </>
  );
};

export default FirstContentProcess;
